const trim = (str: string, symbol: '/' | '\\' | '|' | ' ' = ' '): string =>
  str.replace(new RegExp(`^${symbol}+|${symbol}+$`, 'g'), '');

export default trim;

export const trimEnd = (str: string, symbol: '/' | '\\' | '|' | ' ' = ' '): string =>
  str.replace(new RegExp(`${symbol}+$`, 'g'), '');
